import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const eocReportsTeamRoute: InvariantJiraRoute = {
	name: 'eoc-reports-team',
	path: '/jira/ops/teams/:teamId/reports/:dashboardId',
	exact: true,
};
